import React, { useContext, useState } from 'react';
import { styled } from '@mui/material';

import { ChannelDetailsSection, ControlPanelSection, MessagesSection } from 'components/organisms/Chat';
import { PageContext } from 'pages/Chat/PageProvider';
import { Container, Drawer } from 'shell/components';

const Mobile = () => {
    const {
        activeGroupId,
        setActiveGroupId,
        channels,
        setChannels,
        directs,
        latestMessages,
        setLatestMessages,
        activeChatId,
        setActiveChatId,
        messages,
        setMessages,
        files,
        setFiles,
        deleteMessage,
        setCreateChannelDialog,
        setEditChannelDialog,
        setManageMembersDialog,
        setAlertDialog,
        search,
        setSearch,
        channelDetailsOpen,
        setChannelDetailsOpen,
    } = useContext(PageContext);

    const [open, setOpen] = useState(false);

    const handleClickChat = (id) => {
        setActiveChatId(id);
        setOpen(true);
    };

    return (
        <CustomContainer device={'mobile'}>
            <ControlPanelSection
                activeGroupId={activeGroupId}
                setActiveGroupId={setActiveGroupId}
                channels={channels}
                directs={directs}
                latestMessages={latestMessages}
                activeChatId={activeChatId}
                setActiveChatId={handleClickChat}
                setCreateChannelDialog={setCreateChannelDialog}
                search={search}
                setSearch={setSearch}
            />
            <CustomDrawer device={'mobile'} open={open} onClose={() => setOpen(false)}>
                <MessagesSection
                    activeGroupId={activeGroupId}
                    channels={channels}
                    directs={directs}
                    setLatestMessages={setLatestMessages}
                    activeChatId={activeChatId}
                    messages={messages}
                    setMessages={setMessages}
                    setFiles={setFiles}
                    deleteMessage={deleteMessage}
                    setAlertDialog={setAlertDialog}
                    channelDetailsOpen={channelDetailsOpen}
                    setChannelDetailsOpen={setChannelDetailsOpen}
                    onClickBack={() => setOpen(false)}
                />
            </CustomDrawer>
            <CustomDrawer device={'mobile'} open={channelDetailsOpen} onClose={() => setChannelDetailsOpen(false)}>
                <ChannelDetailsSection
                    activeGroupId={activeGroupId}
                    channels={channels}
                    setChannels={setChannels}
                    directs={directs}
                    activeChatId={activeChatId}
                    setActiveChatId={setActiveChatId}
                    files={files}
                    setEditChannelDialog={setEditChannelDialog}
                    setManageMembersDialog={setManageMembersDialog}
                    setAlertDialog={setAlertDialog}
                    setChannelDetailsOpen={setChannelDetailsOpen}
                />
            </CustomDrawer>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(() => {
    return {
        padding: 0,
    };
});

const CustomDrawer = styled(Drawer)(() => {
    return {
        '& > .MuiDrawer-paper > .MuiBox-root': {
            padding: 0,
        },
    };
});

export default Mobile;
